import React, { useState, useRef, useEffect } from 'react';

export default function TextEditor({ value, column, onSave, onCancel }) {
  const [val, setVal] = useState(value || '');
  const [error, setError] = useState('');
  const inputRef = useRef(null);
  const isEmail = column?.type === 'email';

  useEffect(() => { inputRef.current?.focus(); }, []);

  const validate = (v) => {
    if (isEmail && v && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v)) {
      setError('Email inválido');
      return false;
    }
    setError('');
    return true;
  };

  const handleSave = () => {
    if (validate(val)) onSave(val);
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') handleSave();
    if (e.key === 'Escape') onCancel();
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
        <input
          ref={inputRef}
          type={isEmail ? 'email' : 'text'}
          value={val}
          onChange={e => { setVal(e.target.value); if (error) validate(e.target.value); }}
          onKeyDown={handleKeyDown}
          style={error ? { borderColor: '#e53e3e' } : undefined}
        />
        <button className="cm-cell-edit-btn cm-cell-edit-btn--save" onClick={handleSave}>
          <i className="fas fa-check" />
        </button>
        <button className="cm-cell-edit-btn cm-cell-edit-btn--cancel" onClick={onCancel}>
          <i className="fas fa-times" />
        </button>
      </div>
      {error && <span style={{ color: '#e53e3e', fontSize: 11 }}>{error}</span>}
    </div>
  );
}
